import React from 'react';
import ProfileInputs from './ProfileInputs';
import LanguageSelector from './LanguageSelector';
import { useDataContext } from '../../context/data';
import translations from '../../constants/translations.json';

const ProfileInformation = ({ userProfile, handleChange, saveProfile }) => {
  const { language } = useDataContext();

  return (
    <>
      {/* Personal information card */}
      <div className="bg-white rounded-2xl py-7 shadow-sm">
        <h3 className="text-lg font-bold text-[#1a1a1a] mb-1">
          {translations[language]?.general_information_title}
        </h3>
        <p className="text-[13px] text-gray-400 mb-6">
          {translations[language]?.general_information_description}
        </p>

        <ProfileInputs userProfile={userProfile} handleChange={handleChange} />

        <button
          onClick={saveProfile}
          className="w-full py-[14px] text-[15px] font-semibold bg-primary hover:bg-secondary text-white border-none rounded-xl cursor-pointer transition-colors duration-200 mt-6"
        >
          {translations[language]?.save_information}
        </button>
      </div>

      {/* Language card */}
      <div className="bg-white rounded-2xl py-7 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <span className="text-2xl">🌍</span>
          <div>
            <h3 className="text-lg font-bold text-[#1a1a1a] mb-0.5">
              {translations[language]?.language_text}
            </h3>
            <p className="text-[13px] text-gray-400">
              {translations[language]?.language_description || 'Vælg dit foretrukne sprog'}
            </p>
          </div>
        </div>
        <LanguageSelector />
      </div>
    </>
  );
};

export default ProfileInformation;
